<app-details-wrapper [title]="'UpdateInstitution' | i18n">
  <div class="tw-flex tw-flex-col tw-gap-3 tw-rounded-lg tw-p-3">
    <app-widget [title]="'institutionName' | i18n" [iconName]="'coins'">
      <app-institution-form
        [institutionView]="institutionView()"
        [saveButtonOptions]="saveButtonOptions()"
        [countryOptions]="countryOptions()"
        [institutionOptions]="institutionOptions()"
        [productOptions]="productOptions()"
        [institutionName]="institutionName()"
        [institutionCountry]="institutionCountry()"
        [linkedInstitution]="selectedInstitution()?.name"
        [selectedProduct]="selectedProduct()?.name"
        [linkUnavailable]="isOrgOwned()"
        [hasLink]="!!linkedInstitutionId()"
        [linkRemovalPending]="isLinkRemovalPending()"
        (institutionNameChange)="institutionNameChange($event)"
        (institutionCountryChange)="institutionCountryChange($event)"
        (linkedInstitutionChange)="linkedInstitutionChange($event)"
        (linkedProductChange)="linkedProductChange($event)"
        (linkCleared)="linkCleared()"
        (linkRestored)="linkRestored()"
      ></app-institution-form>
    </app-widget>

    <app-widget [title]="'editHistory' | i18n" [iconName]="'time'"></app-widget>
  </div>
</app-details-wrapper>
